import './GridWrapper.css';

export default function GridWrapper({children, className}) {
    return (
        <div className={`gridWrapper ${className}`}>
            {children}
        </div>
    );
}
